import { OttPlanConstants } from "../constants/ottplan.constants";

const OttPlanReducer = (state, action) => {
  switch (action.type) {
    case OttPlanConstants.FETCH_OTT_PLAN_REQUEST:
      return {
        ...state,
        isLoadingOttPlans: true,
        hasError: false,
      };
    case OttPlanConstants.FETCH_OTT_PLAN_SUCCESS:
      return {
        ...state,
        isLoadingOttPlans: false,
        ottPlans: action.payload.data,
        paging: action.payload.paging,
      };
    case OttPlanConstants.FETCH_OTT_PLAN_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoadingOttPlans: false,
      };

    case OttPlanConstants.DOWNLOAD_OTT_PLAN_REQUEST:
      return {
        ...state,
        isLoadingDownload: true,
        hasError: false,
        downloadFileType: action.payload.fileType,
      };
    case OttPlanConstants.DOWNLOAD_OTT_PLAN_SUCCESS:
      return {
        ...state,
        isLoadingDownload: false,
        downloadFileType: "",
      };
    case OttPlanConstants.DOWNLOAD_OTT_PLAN_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoadingDownload: false,
        downloadFileType: "",
      };

    case OttPlanConstants.OTT_PLAN_AUTO_SEARCH_REQUEST:
      return {
        ...state,
        autoSearchLoading: true,
        hasError: false,
      };
    case OttPlanConstants.OTT_PLAN_AUTO_SEARCH_SUCCESS:
      return {
        ...state,
        autoSearchLoading: false,
        ottPlanAutoSearchResults: action.payload,
      };
    case OttPlanConstants.OTT_PLAN_AUTO_SEARCH_FAILURE:
      return {
        ...state,
        hasError: true,
        autoSearchLoading: false,
      };
    case OttPlanConstants.GET_OTT_PLAN_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case OttPlanConstants.GET_OTT_PLAN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        ottPlan: action.payload,
      };
    case OttPlanConstants.GET_OTT_PLAN_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    default:
      return state;
  }
};

export default OttPlanReducer;
